import { z } from "zod";

// Business Information Schema (extending the existing one)
export const businessInformationSchema = z.object({
  businessName: z.string().min(2, {
    message: "Business name must be at least 2 characters.",
  }),
  contactName: z.string().min(2, {
    message: "Contact name must be at least 2 characters.",
  }),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  phone: z.string().min(10, {
    message: "Please enter a valid phone number.",
  }),
  taxId: z.string().min(2, {
    message: "Tax ID (EIN) is required.",
  }),
  street: z.string().min(4, {
    message: "Street address must be at least 4 characters.",
  }),
  suite: z.string().optional(),
  city: z.string().min(2, {
    message: "City must be at least 2 characters.",
  }),
  state: z.string().min(2, {
    message: "State must be at least 2 characters.",
  }),
  zipCode: z.string().min(5, {
    message: "ZIP code must be at least 5 characters.",
  }),
  country: z.string().min(2, {
    message: "Country must be at least 2 characters.",
  }),
});

// Tax Documents Schema
export const taxDocumentsSchema = z.object({
  taxDocuments: z.array(z.instanceof(File, { message: "Valid file is required" }))
    .max(5, { message: "Maximum 5 files allowed" })
    .refine((files) => {
      if (!files || files.length === 0) return true;
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/jpg',
        'image/png'
      ];
      return files.every(file => allowedTypes.includes(file.type));
    }, { message: "Only PDF, DOC, DOCX, JPG, JPEG, and PNG files are allowed" })
    .optional(),
});


export const paymentMethodsSchema = z.object({

  accountHolderName: z.string().min(2, {
    message: "Account holder name must be at least 2 characters.",
  }),
  bankName: z.string().min(2, {
    message: "Bank name must be at least 2 characters.",
  }),
  routingNumber: z.string().length(9, {
    message: "Routing number must be 9 characters.",
  }),
  accountNumber: z.string().min(8, {
    message: "Account number must be at least 8 characters.",
  }),
 
  paypalConnected: z.boolean().optional(),
  venmoConnected: z.boolean().optional(),
  cashAppConnected: z.boolean().optional(),
});

export type BusinessInformationValues = z.infer<typeof businessInformationSchema>;
export type TaxDocumentsValues = z.infer<typeof taxDocumentsSchema>;
export type PaymentMethodsValues = z.infer<typeof paymentMethodsSchema>; 